<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>出入库记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="城市">
                    <el-select v-model="listQuery.cityId" clearable placeholder="请选择城市" filterable @change="cityChange">
                        <el-option v-for="(item,index) in cityList" :key="index" :label="item.cityName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="仓库">
                    <el-select v-model="listQuery.houseIds" clearable placeholder="请选择仓库" filterable multiple>
                        <el-option v-for="(item,index) in houseList" :key="index" :label="item.houseName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务单类型">
                    <el-select v-model="listQuery.relationType" clearable placeholder="请选择类型" filterable>
                        <el-option v-for="(item,index) in typeList" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="关联业务单号">
                    <el-input v-model="listQuery.relationNo" placeholder="请输入关联业务单号" clearable></el-input>
                </el-form-item>

                <el-form-item label="出入库订单ID">
                    <el-input v-model="listQuery.stockOrderId" placeholder="请输入出入库订单ID" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品SKU">
                    <el-input v-model="listQuery.skuCode" placeholder="请输入商品SKU" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品SN码">
                    <el-input v-model="listQuery.snCode" placeholder="请输入商品SN码" clearable></el-input>
                </el-form-item>

                <el-form-item label="商品名称">
                    <el-input v-model="listQuery.skuName" placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品成本价">
                    <el-input type="number" v-model="listQuery.costPrice" placeholder="请输入商品成本价" clearable></el-input>
                </el-form-item>

                <el-form-item label="日期">
                    <el-date-picker v-model="timePart" type="daterange" range-separator="至" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="stockOrderId" label="出入库订单id"></el-table-column>
                <el-table-column prop="relationNo" label="业务单号"></el-table-column>
                <el-table-column prop="relationType" label="业务类型">
                    <template slot-scope="scope">{{scope.row.relationType | typeFilter}}</template>
                </el-table-column>
                <el-table-column prop="inOrOut" label="出入库类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.inOrOut==1">入库</span>
                        <span v-if="scope.row.inOrOut==2">出库</span>
                    </template>
                </el-table-column>
                <el-table-column prop="houseName" label="仓库名称"></el-table-column>
                <el-table-column prop="skuCode" label="商品SKU"></el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="snCode" label="商品SN码"></el-table-column>
                <el-table-column prop="costPrice" label="成本价"></el-table-column>
                <el-table-column prop="stockCurrIn" label="本次入库"></el-table-column>
                <el-table-column prop="stockCurrOut" label="本次出库"></el-table-column>
                <el-table-column prop="stockOriginal" label="原有库存"></el-table-column>
                <el-table-column prop="stockSurplus" label="本次剩余库存"></el-table-column>
                <el-table-column prop="stockOriginalAll" label="商品原总库存"></el-table-column>
                <el-table-column prop="stockOriginalAllSurplus" label="商品剩余总库存"></el-table-column>
                <el-table-column prop="createTime" label="操作时间" :formatter="dateFormatA" width="140px"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            typeList: [
                { id: 1, text: "采购单入库单" },
                { id: 2, text: "销售单" },
                { id: 3, text: "转仓单" },
                { id: 4, text: "盘库单" },
                { id: 5, text: "租赁归还单" },
            ],
            listData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                // cityId: "",
                houseIds: [],
                stockOrderId: null,
                relationNo: null,
                relationType: null,
                inOrOut: null,

                skuCode: null,
                skuName: null,
                snCode: null,
                costPrice: null,
                startTime: null,
                endTime: null,
            },

            timePart: [],
            cityList: [],
            houseList: [],
            tempHouseList: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近半个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 15
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    activated() {
        //其他业务跳转接收skuCode查询
        // console.log(this.$route.query.skuCode);
        let skuCode = this.$route.query.skuCode;
        let relationNo = this.$route.query.relationNo;
        let houseId = this.$route.query.houseId;
        this.listQuery.skuCode = skuCode;
        this.listQuery.relationNo = relationNo;
        this.listQuery.houseIds = houseId == null ? [] : [houseId*1];
        // if (skuCode!=null||relationNo!=null||houseId!=null) {
        // this.querySearch();
        //}
        this.querySearch();
    },
    created() {
        this.getAllCity();
        this.getAllHouse();
        // this.querySearch();
    },
    methods: {
        routerParm() {
            this.currentPage = 1;
            this.querySearch();
        },
        cityChange(cityId) {
            this.listQuery.houseIds = [];
            let temparr = [];
            this.tempHouseList.filter((item) => {
                if (item.cityId == cityId) {
                    temparr.push(item);
                }
            });
            this.houseList = temparr;
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            this.listQuery.startTime = null;
            this.listQuery.endTime = null;
            if (this.timePart != "" && this.timePart != undefined) {
                this.listQuery.startTime = this.timePart[0] + " 00:00:00";
                this.listQuery.endTime = this.timePart[1] + " 23:59:59";
            }
            wmsApi
                .$axiosWmsHouseStockgetStockLogPage(this.listQuery)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.list;
                        this.total = res.data.data.total;
                    }
                });
        },
        getAllCity() {
            //城市下拉框
            wmsApi.$axiosgetallCity().then((res) => {
                if (res.data.errno == 0) {
                    this.cityList = res.data.data;
                }
            });
        },
        getAllHouse() {
            //仓库下拉框
            wmsApi
                .$axiosgetAllHouse({ sysUserId: globalData.userInfo.id })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.houseList = res.data.data;
                        this.tempHouseList = res.data.data;
                        // if (this.houseList.length > 0) {
                        //     let arr = [];
                        //     this.houseList.forEach((e) => {
                        //         if (e.mark) {
                        //             arr.push(e.id);
                        //         }
                        //     });
                        //     console.log(arr);
                        //     this.listQuery.houseIds = arr;
                        //     this.querySearch();
                        // }
                    }
                });
        },
    },
    beforeCreate() {
        vm = this;
    },
    filters: {
        typeFilter(value) {
            const rs = vm.typeList.filter((item) => {
                return item.id === value;
            });

            if (rs != null && rs.length > 0) {
                return rs[0].text;
            }
        },
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>